/**
 * Created by valentin on 19/07/2017.
 */
import React from 'react'
import logo from '../../../logo.svg'
import { polyglot } from '../../../index'

export default class DoctorProfile extends React.Component {
  render () {
    return <div>
      <div className='row center'>
        <div className='col-sm-12 col-md-12'>
          <div className='thumbnail'>
            <img className='patient-photo' src={logo} alt={polyglot.t('staticText.profilePhoto')} />
            <div className='caption'>
              <h2>{this.props.patient}</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
}



// WEBPACK FOOTER //
// ./src/components/general/DoctorProfile/DoctorProfile.js